import { Injectable, signal } from '@angular/core'

@Injectable({ providedIn: 'root' })
export class UndoRedoService<T> {
  private readonly _undoStack = signal<T[]>([])
  private readonly _redoStack = signal<T[]>([])

  /** Save a snapshot for undo */
  push(state: T): void {
    this._undoStack.set([...this._undoStack(), structuredClone(state)])
    this._redoStack.set([])
  }

  /** Revert to last snapshot */
  undo(current: T): T | undefined {
    const stack = this._undoStack()
    if (!stack.length) return undefined
    const previous = stack[stack.length - 1]
    this._undoStack.set(stack.slice(0, -1))
    this._redoStack.set([...this._redoStack(), structuredClone(current)])
    return previous
  }

  /** Reapply a reverted snapshot */
  redo(current: T): T | undefined {
    const stack = this._redoStack()
    if (!stack.length) return undefined
    const next = stack[stack.length - 1]
    this._redoStack.set(stack.slice(0, -1))
    this._undoStack.set([...this._undoStack(), structuredClone(current)])
    return next
  }

  /** Clear history */
  clear(): void {
    this._undoStack.set([])
    this._redoStack.set([])
  }
}
